import { prodapiAxiosClient } from "./prodApiClient";

const search = (query) => {
    return prodapiAxiosClient
    .post("/api/v1/search/", query)
}

const searchApi = {search}
export default searchApi;